import Typed from "react-typed";
import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
import log from "cslog";

function isFloat(n) {
    return n === +n && n !== (n | 0);
}

function Rating({ id, db, device, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    const styleRaingBar = decodeStyle(ps.styleGroup.ratingBar, gs);
    const styleIcon = decodeStyle(ps.styleGroup.icon, gs);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const filled = input.filledStars;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    // padding: "15px",
                    justifyContent: input.alignItems,
                    gap: `${input.itemGap - 0.5}rem`,
                    ...styleRaingBar,
                }}
            >
                {[...Array(input.totalStars).keys()].map((_, index) => {
                    const isFilled = index + 1 <= filled;
                    if (index < filled && index + 1 > filled) {
                        const diff = filled - index;
                        return (
                            <div
                                style={{
                                    position: "relative",
                                }}
                            >
                                <span
                                    style={{
                                        // position: "absolute",
                                        fontSize: input.iconSize.value,
                                        color: styleIcon.remainingColor,
                                        WebkitTextStrokeColor:
                                            styleIcon.strokeColor,
                                        WebkitTextStrokeWidth:
                                            styleIcon.strokeWidth,
                                    }}
                                >
                                    <i className={input.iconSource?.value}></i>
                                </span>
                                <span
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        fontSize: input.iconSize.value,
                                        color: styleIcon.filledColor,
                                        clipPath: `polygon(0% 0%, ${
                                            diff * 100
                                        }% 0%, ${diff * 100}% 100%, 0% 100%)`,
                                        WebkitTextStrokeColor:
                                            styleIcon.strokeColor,
                                        WebkitTextStrokeWidth:
                                            styleIcon.strokeWidth,
                                    }}
                                >
                                    <i className={input.iconSource?.value}></i>
                                </span>
                            </div>
                        );
                    }
                    return (
                        <span
                            key={index}
                            style={{
                                fontSize: input.iconSize.value,
                                color: isFilled
                                    ? styleIcon.filledColor
                                    : styleIcon.remainingColor,
                                WebkitTextStrokeColor: styleIcon.strokeColor,
                                WebkitTextStrokeWidth: styleIcon.strokeWidth,
                            }}
                        >
                            <i className={input.iconSource?.value}></i>
                        </span>
                    );
                })}
            </div>
        </div>
    );
}

export default Rating;
